import { toast } from 'vue3-toastify'
import { App } from '@/common/rails'

const ignorePaths = [
  '/sign_up', '/sign_in', '/password/new', '/password',
  '/stats/reports/', '/stats/gmb/locations/', '/stats/geogrids/', '/stats/audit_reports/',
  '/lsa'
]

export default function setupActionCable() {
  if (ignorePaths.some((i) => window.location.pathname.includes(i))) {
    return
  }

  App.cable.subscriptions.create('PlacesChannel', {
    received: (msg) => {
      if (msg.type === 'geogrid.error') {
        toast.error(
          `${msg.info}.</br>Visit <a href="/geogrids"><u>GeoGrid Search page</u></a> for more details.`,
          { autoClose: false, dangerouslyHTMLString: true }
        )
      } else if (msg.type === 'geogrid.finished') {
        toast.success(
          `<a href="${msg.geogrid_link}"><u>${msg.info}</u></a>.`,
          { dangerouslyHTMLString: true }
        )
      } else if (msg.type === 'scheduled_geogrids.finished') {
        toast.success('All your GeoGrids are ready!', null, { autoClose: false })
      }
    }
  })
}
